import React,{useState} from 'react'
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import BASE_URL from '../context/AppConfig';

function Login() {
    const [formData, setFormData] = useState({ username: '', password: '' });
    const [error, setError] = useState(null);
    const navigate = useNavigate(); 
    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    }
    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await axios.post(`${BASE_URL}/signin/`, formData);
            console.log(response.data);
        }
        catch (error) {
            console.error('Login failed:', error);
            setError('Login failed. Please check your credentials.');
        }
    }

  return (
    <div>
      <form onSubmit={handleSubmit}>
        <input name="username" placeholder="Username" value={formData.username} onChange={handleChange} required />
        <input name="password" type="password" placeholder="Password" value={formData.password} onChange={handleChange} required />
        <button type="submit">Login</button>

      </form>
    </div>
  )
}

export default Login
